import {
  GET_CLUB_SUCCESS,
  CLUB_REQUESTING,
  LIST_CLUBS_SUCCESS,
  RESET_CLUB_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case CLUB_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_CLUBS_SUCCESS: {
      const data = { ...state.data };
      action.payload.clubs.forEach((object) => {
        data[object.id] = object;
      });
      return {
        data,
        isFetching: false
      };
    }
    case GET_CLUB_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getClubBySlug = (clubs, slug) => {
  if (!clubs.data) {
    return null;
  }
  const clubIds = Object.keys(clubs.data);
  const clubBySlugId = clubIds.find((id) => clubs.data[id].slug === slug);
  if (clubBySlugId) {
    return clubs.data[clubBySlugId];
  }
  return null;
};
